export default {
    title: 'Sprzęty',
    subtitle: '{n} sprzęt | {n} sprzęty | {n} sprzętów',
    newDevice: 'Nowy sprzęt',
    search: 'Szukaj sprzętu',
    add: {
        placeholder: 'Dodaj sprzęt…',
        save: 'Dodaj',
    },
    kinds: {
        car: 'Auto',
        appliance: 'AGD',
        electronics: 'Elektronika',
        home: 'Dom',
        bike: 'Rower',
        other: 'Inne',
    },
    fields: {
        name: 'Nazwa',
        namePlaceholder: 'Nazwa, np. Pralka',
        kind: 'Rodzaj',
        brand: 'Marka',
        brandPlaceholder: 'np. Bosch',
        model: 'Model',
        modelPlaceholder: 'np. Serie 6',
        purchasedOn: 'Data zakupu',
        warrantyUntil: 'Gwarancja do',
    },
    warranty: {
        title: 'Gwarancja',
        until: 'do {date}',
        endsIn: 'kończy się za {n} dzień | kończy się za {n} dni | kończy się za {n} dni',
        endsToday: 'kończy się dziś',
        ended: 'po gwarancji',
        hint: 'Wpisz, do kiedy sprzęt jest na gwarancji — miesiąc wcześniej przypomni się w „Teraz".',
    },
    mileage: {
        title: 'Przebieg',
        last: '{km} km · {date}',
        perMonth: 'średnio ~{km} km/mies.',
        perMonthUnknown: 'średnią policzę po dwóch pomiarach odległych o 2 tygodnie',
        empty: 'Wpisuj stan licznika co jakiś czas — z tego policzę, kiedy wypadnie obsługa „co N km".',
        add: 'Dodaj pomiar',
        addCounter: 'Dodaj licznik',
        km: 'Stan licznika',
        kmPlaceholder: 'np. 123 400',
        date: 'Dzień',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń pomiar',
        all: 'Wszystkie ({n})',
        less: 'Mniej',
    },
    costs: {
        title: 'Koszty',
        total: 'na wszystkie obsługi',
        empty: 'Gdy przy „Zrobione" wpiszesz koszt, tu zobaczysz sumę.',
    },
    notes: {
        title: 'Notatka',
        placeholder: 'Numer seryjny, gdzie serwisować, rozmiar filtra…',
    },
    empty: {
        title: 'Nie ma tu jeszcze sprzętów',
        text: 'Dodaj auto, pralkę albo rower — przeglądy, serwisy i koniec gwarancji przypomną się same.',
        noMatchTitle: 'Nic nie pasuje',
        noMatchText: 'Zmień frazę albo wyczyść pole szukania.',
    },
    pick: {
        title: 'Wybierz sprzęt',
        text: 'Albo dodaj nowy w polu nad listą.',
    },
    toolbar: {
        back: 'Wróć do listy',
        remove: 'Usuń sprzęt',
        saving: 'Zapisywanie…',
        saveError: 'Nie udało się zapisać — spróbujemy przy następnej zmianie',
    },
    toast: {
        removed: 'Usunięto: {name}',
    },
    help: {
        add: {
            title: 'Dodaj sprzęt',
            text: 'Wpisz nazwę, wybierz rodzaj i naciśnij Enter. Resztę uzupełnisz po prawej.',
            more: 'Asystent też doda sprzęt, gdy powiesz np. „gwarancja na pralkę do maja 2028".',
        },
        list: {
            title: 'Twoje sprzęty',
            text: 'Na górze te, którym najbliżej do obsługi. Plakietki mówią, co i kiedy, i czy kończy się gwarancja.',
            more: 'Pomarańczowa plakietka znaczy, że termin już minął albo gwarancja kończy się w ciągu miesiąca. Kwota z prawej to suma kosztów.',
        },
        cares: {
            title: 'Obsługi',
            text: 'Przegląd, wymiana oleju, odkamienianie… Ustaw, co ile miesięcy, a „Zrobione" zapisze dzień i koszt i przesunie następny termin.',
            more: 'Termin możesz też wpisać ręcznie — obowiązuje do następnego „Zrobione". Tydzień wcześniej obsługa pojawi się w „Teraz" i w Planerze.',
        },
        warranty: {
            title: 'Gwarancja',
            text: 'Dzień, do którego sprzęt jest na gwarancji. Miesiąc przed końcem przypomni się w „Teraz".',
            more: 'Data zakupu jest obok — przyda się przy reklamacji.',
        },
        costs: {
            title: 'Koszty',
            text: 'Suma kosztów wszystkich wykonań obsług i ile wyszło na każdą.',
            more: 'Pojedyncze kwoty są w historii przy obsłudze.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Sprzętach',
            description: 'Miejsce na rzeczy, o które trzeba dbać: auto, pralka, rower. Przeglądy, serwisy, koszty i gwarancja w jednym miejscu.',
        },
        device: {
            title: 'Sprzęt',
            description: 'Po prawej: nazwa, rodzaj, marka i model, gwarancja, obsługi z przyciskiem „Zrobione", koszty i notatka. Wszystko zapisuje się samo.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    firstSteps: {
        device: {
            title: 'Pierwszy sprzęt',
            action: 'Dodaj sprzęt',
            what: 'Wpisz nazwę w pole „Dodaj sprzęt…", wybierz rodzaj i naciśnij Enter.',
            why: 'Obsługi, koszty i gwarancja są przy sprzęcie.',
        },
        care: {
            title: 'Obsługa',
            action: 'Dodaj obsługę',
            what: 'Otwórz sprzęt i dodaj np. przegląd albo odkamienianie — z podpowiedzi albo pod własną nazwą.',
            why: 'Termin przypomni się w „Teraz" i w Planerze.',
        },
        done: {
            title: 'Zrobione',
            action: 'Zapisz wykonanie',
            what: 'Kliknij „Zrobione" przy obsłudze — z dniem, kosztem i notatką.',
            why: 'Następny termin policzy się od tego dnia, a koszt doliczy do sumy.',
        },
        warranty: {
            title: 'Gwarancja',
            action: 'Wpisz gwarancję',
            what: 'Wpisz przy sprzęcie, do kiedy jest na gwarancji.',
            why: 'Miesiąc przed końcem przypomni się w „Teraz".',
        },
    },
};
